export const getURL = url => {
  try {
    return new URL(url);
  } catch (error) {
    // ie11
    var href = document.createElement("a");
    href.href = url;
    return href;
  }
};

export const parseQueryString = search => {
  const objURL = {};
  const queryIndex = search.indexOf("?");
  if (queryIndex >= 0) {
    search = search.slice(queryIndex);
    search.replace(
      new RegExp("([^?=&]+)(=([^&]*))?", "g"),
      ($0, $1, $2, $3) => {
        try {
          objURL[$1] = decodeURIComponent($3);
        } catch (e) {
          objURL[$1] = $3;
        }
      }
    );
  }
  return objURL;
};

export const removeTrailingSlash = string => string.replace(/(.*)\/$/, "$1");

export const getLegacyRedirect = () => {
  if (
    Fraction.redirectAfterSignIn &&
    Fraction.redirectAfterSignIn !== "undefined"
  ) {
    const queryParams = Fraction.queryAfterSignIn || {};
    const url = getURL(Fraction.redirectAfterSignIn.join("/"));
    const hash = `#${url.pathname}`;
    const hashParams = { ...parseQueryString(hash), ...queryParams };
    const search =
      "?" +
      Object.keys(hashParams)
        .reduce((acc, key) => {
          acc.push(`${key}=${hashParams[key]}`);
          return acc;
        }, [])
        .join("&");
    return {
      hash: hash.split("?")[0],
      host: url.host,
      hostname: url.hostname,
      href: `${url.origin}/${hash}${search}`,
      origin: url.origin,
      pathname: "/",
      port: url.port,
      protocol: url.protocol,
      search: search
    };
  }
};

export const _getURL = url => {
  try {
    return new URL(url);
  } catch (error) {
    // ie11
    var href = document.createElement("a");
    href.href = url;
    return href;
  }
};

export const isRelativeURL = dest => {
  const url = _getURL(dest);
  return (
    (url.protocol === "" || url.protocol === window.location.protocol) &&
    (url.hostname === window.location.hostname || url.hostname === "")
  );
};

export const alohomoraRedirectURL = (alohomoraHost, location, currentRoute) => {
  let destination = "/";
  const url = new URL(currentRoute.href || window.location.href);
  const queryParams = parseQueryString(location.search);
  const afterParam = queryParams["after"] || queryParams["after_eula"];
  const afterURI = afterParam ? new URL(afterParam) : "";

  if (url.href.indexOf("/user/decide") > 0) {
    destination = "/user/decide";
    url.pathname = "/";
    url.hash = url.hash.replace("user/decide", "");
  }

  if (url.href.indexOf("/user/sso") > 0) {
    destination = "/user/sso";
    url.pathname = "/";
    url.hash = url.hash.replace("user/sso", "");
  }

  if (url.href.indexOf("/user/complete") > 0) {
    destination = "/user/complete";
    url.pathname = "/";
    url.hash = url.hash.replace("user/complete", "");
  }

  if (url.href.indexOf("/user/activation") > 0) {
    destination = "/activate";
    url.pathname = "/";
    url.hash = url.hash.replace("user/activation", "");
  }

  if (url.href.indexOf("/user/check") > 0) {
    const userCheckDestination = decodeURIComponent(
      queryParams["userCheckReturnTo"] || "/"
    );
    const [userCheckPath, userCheckSearch] = userCheckDestination.split("?");
    destination = "/";
    url.pathname = userCheckPath;
    url.search = userCheckSearch || "";
    url.hash = "";
  }

  return `https://${alohomoraHost}${destination}?redirect_uri=${
    afterURI ? encodeURIComponent(afterURI) : encodeURIComponent(url.href)
  }&brand=${url.hostname}&context=bookshelf`;
};
